import axios from 'axios'

export default {
  getEvent (token) {
    return axios
      .get('event/' + token)
      .then(resp => {
        return resp.data
      })
  },
  getEventCategories (token) {
    return axios
      .get('event/' + token + '/categories')
      .then(resp => {
        return resp.data
      })
  },
  getEventParticipants (token) {
    return axios
      .get('participants/' + token)
      .then(resp => {
        return resp.data
      })
  }
}
